import { Link } from 'react-router-dom';
import { LogoLibraryButton } from '../LogoLibraryButton';
import { HeaderInfoButtons } from '../HeaderInfoButtons';
import { UserMenu } from './UserMenu';
import styles from './TopBar.module.css';

export function TopBar() {
  const today = new Date().toLocaleDateString('cs-CZ', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <div className={styles.bar}>
      <Link to="/app" className={styles.brand} title="Zpět na rozcestník" aria-label="Zpět na rozcestník">
        <div className={styles.logo}>S</div>
        <span className={styles.brandName}>SiteDoc</span>
      </Link>

      <div className={styles.search}>
        <span className={styles.searchIcon} aria-hidden>
          ⌕
        </span>
        <input type="search" className={styles.searchInput} placeholder="Hledat stavbu, dokument, zakázku…" aria-label="Globální vyhledávání" />
      </div>

      <div className={styles.actions}>
        <HeaderInfoButtons />
        <LogoLibraryButton />
        <div className={styles.meta}>{today}</div>
        <UserMenu />
      </div>
    </div>
  );
}
